import { createStyles, makeStyles } from '@material-ui/core/styles'
import { uniqBy } from 'lodash'
import { useEffect, useState } from 'react'
import { Loading } from 'react-admin'

import { getZendeskTickets } from '../../api/zendesk'
import { ZendeskTickets } from '../Zendesk/ZendeskTickets'

interface JobZendeskTicketsProps {
  user: any
}

const useStyles = makeStyles(() =>
  createStyles({
    loading: {
      height: 'auto',
      marginTop: '50px',
    },
  })
)

export function UserZendeskTickets({ user }: JobZendeskTicketsProps) {
  // Dummy data, uncomment to test in dev
  // user.email = 'javonjohnsonc4@hotmail.com'
  const styles = useStyles()
  const [loading, setLoading] = useState(true)
  const [tickets, setTickets] = useState<any>([])

  useEffect(() => {
    if (user?.email) {
      getZendeskTickets({
        query: user.email,
      }).then((data: any) => {
        setTickets((tickets: any) => [...tickets, ...data.tickets])
        setLoading(false)
      })

      getZendeskTickets({
        email: user.email,
      }).then((data: any) => {
        setTickets((tickets: any) => [...tickets, ...data.tickets])
        setLoading(false)
      })
    }
  }, [user.email])

  if (loading) {
    return <Loading className={styles.loading} />
  }

  return <ZendeskTickets tickets={uniqBy(tickets, 'id')} />
}
